import { createColumnHelper } from '@tanstack/react-table';
import Table from '../../Common/components/Table';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Settings, Merge } from 'lucide-react';
import MergeSessionsModal from './MergeSessionsModal';
import moment from 'moment-timezone';
import { Button } from '@/src/shadComponents/ui/button';
const columnHelper = createColumnHelper<any>();

interface SessionStatsTableProps {
    activationId: number;
    sessionStats: any[];
}

export default function SessionStatsTable({
    activationId,
    sessionStats,
}: SessionStatsTableProps) {
    const [mergeSessions, setMergeSessions] = useState<boolean>(false);
    const [selectedSession, setSelectedSession] = useState<string | null>(null);
    const columns = [
        columnHelper.accessor('date', {
            id: 'date',
            header: () => <span>time</span>,
            cell: (info) => (
                <div className="row">
                    <span>
                        {moment(info.getValue()).format('MMM D, YYYY h:mm a')}
                    </span>
                </div>
            ),
        }),
        columnHelper.accessor('total', {
            id: 'total',
            header: () => <span>photos</span>,
            cell: (info) => (
                <div className="row">
                    <span>{info.getValue()}</span>
                </div>
            ),
        }),
        columnHelper.accessor('destination', {
            id: 'destination',
            header: () => <span>recipient</span>,
            cell: (info) => (
                <div className="row">
                    <span>{info.getValue() ? info.getValue() : '-'}</span>
                </div>
            ),
        }),
        columnHelper.accessor('sent', {
            id: 'sent',
            header: () => <span></span>,
            cell: (info) => (
                <div className="row">
                    <span>{info.getValue() ? 'Sent' : 'Not Sent'}</span>
                </div>
            ),
        }),
        columnHelper.display({
            id: 'actions',
            cell: (props: { row: any }) => (
                <div className="flex items-center gap-1">
                    <Link
                        to={`/activations/${activationId}/sessions/${props.row.original.photoSessionId}`}
                    >
                        <Button variant="ghost" size="icon">
                            <Settings className="size-4" />
                        </Button>
                    </Link>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => {
                            setMergeSessions(true);
                            setSelectedSession(
                                props.row.original.photoSessionId,
                            );
                        }}
                        title="Merge"
                    >
                        <Merge className="size-4" />
                    </Button>
                </div>
            ),
        }),
    ];

    return (
        <div>
            <div className="flex justify-end mr-8">
                <Link to={`/activations/${activationId}/sessions/create`}>
                    <Button variant="outline">
                        Create New Session
                    </Button>
                </Link>
            </div>
            <Table columns={columns} data={sessionStats} />
            {mergeSessions && (
                <div>
                    {selectedSession && (
                        <MergeSessionsModal
                            photoSessionId={selectedSession}
                            sessions={sessionStats}
                            onComplete={() => {
                                setMergeSessions(false);
                                setSelectedSession(null);
                            }}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
